import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { providerApi } from "../../api/providerApi"
import { Alert, Spin, Collapse, Card, Button, message } from "antd"
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

const ShowProviderView = () => {
    const {id} = useParams()
    const [provider, setProvider] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
      };
    
      const fetchProvider = async () => {
        setLoading(true);
        setError(null);
        try {
          const res = await providerApi.getProvider(`${id}`,abortController.signal);
          setProvider(res.data); // Stocker les données récupérées

          // console.log("details",res.data)
        } catch (err) {
          setError("Impossible de charger les détails du prestataire.");
        } finally {
          setLoading(false);
        }
      };
    useEffect(() => {
        // Définir la fonction fetchProvider à l'intérieur de useEffect
        
    
        fetchProvider(); // Appeler la fonction immédiatement
    
      }, [id]);
      
    const handleDeactivate = async (provider) =>{
      // console.log(provider)
      try {
        const res = await providerApi.canManageAnnonce(`${provider.user_id}`,abortController.signal)
        if (res.success == true) {
          message.success("Gestion d'annonce desactivé pour cet utilisateur avec succès");
        }else{
          message.error(res.message);
        }

        fetchProvider()

      } catch (error) {
        console.error(error);
          setLoading(false);
          message.error("Échec d'activation des informations");
      }
    }

    const handleActivate = async (provider) =>{
      // console.log(provider)
      try {
        const res = await providerApi.canManageAnnonce(`${provider.user_id}`,abortController.signal)
        if (res.success === true) {
          message.success("Gestion d'annonce activé pour cet utilisateur avec succès");
        }else{
          message.error(res.message);
        }

        fetchProvider()
      } catch (error) {
        console.error(error);
          setLoading(false);
          message.error("Échec d'activation des informations");
      }
    }

    return <MainLayout>
    <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails du Prestataire</h1>
            <Link to={`/gestion-prestataires/liste`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && provider && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations personnelles" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom :</strong> {provider.name} {provider.lastname}</p>
                <p><strong>Email :</strong> {provider.email || "Non fourni"}</p>
                <p><strong>Numéro de téléphone :</strong> {provider.contact || "Non fourni"}</p>
                <p><strong>Specialite :</strong> {provider.speciality || "Non fourni"}</p>
                

                <p><strong>Date d'ajout :</strong> {formatDate(provider.created_at)}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Informations de contact" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Adresse :</strong> {provider.adresse || "Non fournie"}</p>
                <p><strong>Ville :</strong> {provider.ville || "Non fournie"}</p>


                {provider.contacts.map((contact,index) => (
                    <p key={index}><strong>Contact {++index} :</strong> {contact.phone || "Non fournie"}</p>

                )) }
              </div>
            </Panel>
          </Collapse>

          {/* Information sur la société */}
          <Collapse defaultActiveKey={['3']} expandIconPosition="start" className="mt-4">
            <Panel header="Société" key="3" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom de la société :</strong> {provider.societe.libelle || "Non fourni"}</p>
                <p><strong>Lieu :</strong> {provider.societe.lieu || "Non fournie"}</p>
                <p><strong>Experience :</strong> <a href={provider.experience} target="_blank" rel="noopener noreferrer">{provider.website || "Non fourni"}</a></p>
              </div>
            </Panel>
          </Collapse>

          {/* Presentation/description*/}
          <Collapse defaultActiveKey={['4']} expandIconPosition="start" className="mt-4">
            <Panel header="Description" key="4" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p>{provider.societe.presentation || "Non fourni"}</p>
                </div>
            </Panel>
          </Collapse>
          
          <div className="mt-2">
              {
                provider?.user?.manage_announce_module === 1 &&
                <Button onClick={()=> handleDeactivate(provider)} className="btn bg-red-700 text-white rounded-md">Desactiver la gestion des annonce</Button>
              }
              {
                provider?.user?.manage_announce_module === 0 &&
                <Button onClick={()=> handleActivate(provider)} className="btn bg-blue-700 text-white rounded-md">Activer la gestion des annonces</Button>
              }
          </div>
          
        </div>

        
      )}
    </div>
  </MainLayout>

}
export default ShowProviderView